export default __webpack_public_path__ + "static/media/2017-06_ExpensePlatform.8006e5a7.jpg";